import React, { useState } from 'react';
import theme from '../theme';
import { validateAndSanitizeText } from '../utils/sanitization';

function TodoModal({ show, onClose, onSave, plantGroup = null }) {
  const [todoText, setTodoText] = useState('');
  const [dueDate, setDueDate] = useState('');

  if (!show) return null;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!todoText.trim()) {
      alert('Please enter a todo item');
      return;
    }

    // Sanitize user input before saving
    const todo = {
      id: Date.now().toString(),
      text: validateAndSanitizeText(todoText.trim(), 2000),
      dueDate: dueDate || null,
      plantGroupId: plantGroup?.id || null,
      plantGroupName: plantGroup?.plantName || null,
      completed: false,
      createdAt: new Date().toISOString()
    };

    onSave(todo);
    setTodoText('');
    setDueDate('');
    onClose();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1001
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '500px',
        width: '90%'
      }}>
        <h2>Add Todo{plantGroup ? ` for ${plantGroup.plantName}` : ''}</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label htmlFor="todoText" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              Todo Item:
            </label>
            <textarea
              id="todoText"
              value={todoText}
              onChange={(e) => setTodoText(e.target.value)}
              placeholder="Enter todo description..."
              style={{ width: '100%', padding: '8px', fontSize: '14px', minHeight: '80px' }}
              required
              autoFocus
            />
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label htmlFor="dueDate" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              Due Date (optional):
            </label>
            <input
              id="dueDate"
              type="date"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
              style={{ width: '100%', padding: '8px', fontSize: '14px' }}
            />
          </div>

          {plantGroup && (
            <div style={{
              backgroundColor: theme.colors.primaryPale,
              padding: '10px',
              borderRadius: '5px',
              marginBottom: '15px',
              fontSize: '13px'
            }}>
              <strong>Plant Group:</strong> {plantGroup.plantName}
              <br />
              <strong>Slot:</strong> {plantGroup.slotName}
            </div>
          )}

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={() => {
                setTodoText('');
                setDueDate('');
                onClose();
              }}
              style={{
                padding: '10px 20px',
                backgroundColor: theme.colors.mediumGrey,
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                padding: '10px 20px',
                backgroundColor: theme.colors.success,
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Add Todo
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default TodoModal;
